import * as angular from 'angular';
import {IController} from "angular";

export class ServiceChatButtonComponent implements IController {
  serviceId: string;

  /* @ngInject */
  constructor() {

  }

  $onInit() {

  }


}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceChatButton', {
    bindings: {
      serviceId: '<'
    },
    template: require('./service-chat-button.html').default,
    controller: ServiceChatButtonComponent
  });
